import { arrayToTree } from "../../../util";
import { IIndexTypeCategory } from "../../model/IndexTypeCategory";
import { IIndexTypeGroup } from "../../model/IndexTypeGroup";
import IndexTypeGroupPresentationModel, {
  TIndexTypeGroupPresentationModel
} from "./IndexTypeGroupPresentationModel";

export interface TGroupTreePresentationModel {
  toTree: TIndexTypeGroupPresentationModel[];
  toFlatArray: TIndexTypeGroupPresentationModel[];
}

const GroupTreePresentationModel = (
  data: IIndexTypeGroup[],
  indexTypeCategories?: IIndexTypeCategory[]
) => {
  const handler: ProxyHandler<IIndexTypeGroup[]> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "toTree":
          return arrayToTree(data, null, "parentId", "groups")?.map((item) =>
            IndexTypeGroupPresentationModel(item, indexTypeCategories)
          );
        case "toFlatArray":
          return data?.map((item) =>
            IndexTypeGroupPresentationModel(item, indexTypeCategories)
          );
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "groups":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IIndexTypeGroup[], TGroupTreePresentationModel>(
    data,
    handler
  );
};

export default GroupTreePresentationModel;
